Controller = App.loadClass 'core::Angular/Controller'
Socket = require('resources/assets/coffee/Core/Socket').Socket

class exports.SafeLinkController extends Controller
    constructor: (@scope, @transitions, @service, @session) ->
        super

        @scope.safeLinkSearch = ''
        @scope.users = []
        @scope.login_user = null
        @scope.linked_user = null
        @scope.loadSafeLink = @loadSafeLink
        @scope.handleViewingUser = @handleViewingUser

        @loadAccessUser()
        @loadCompany()
        @scope.loadSafeLink(false)


    loadAccessUser: () =>
        @service.loadAccessUser().then (response) =>
            @scope.login_user = response.data.data.authUser
            @scope.linked_user = response.data.data.safeLinkUser
            @handleViewingUser @scope.linked_user, false

            App.is_safelinking = @scope.login_user.id isnt @scope.linked_user.id

    loadCompany: () =>
        @service.loadCompany().then (response) =>
            @scope.company = response.data.internal_name


    loadSafeLink: (append, e) =>
        @service.loadSafeLink(@scope.safeLinkSearch, append).then (response) =>
            jsr = response.data
            if append
                @scope.users = @scope.users.concat(jsr.data.users)
            else
                @scope.users = jsr.data.users


    handleViewingUser: (user, reload_page = true) =>
        # this can be used to make sure nothing is done before the process of safelinking finishes
        # only run this when triggered from actual safe linking, not page load
        window.dispatchEvent(new Event('app:safelinking')) if reload_page

        App.addPopup('NonExistentUserDialog') if user is null

        @scope.linked_user = user

        @service.fetchPermissions(user.id).then (response) =>
            jsr = response.data
            if jsr.status.type is 'success'

                # Reset the user id who we are viewing data for and reestablish the websocket
                # TODO: jQuery below will need to be angularized
                #       ^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^ yeah no kidding. Someone should do that. This is gross
                $('#ws_user_id').val user.id
                #Socket.reconnect()

                permissions = jsr.data?.permissions
                token = jsr.data?.token

                navLinks = $('#nav_primary_links').children('li')
                options =
                    animation: true,
                    placement: 'bottom',
                    title: "
                        You do not have access to view this part of the
                        currently selected user's account
                    "
                    trigger: 'hover',
                    delay: 0

                # If it's empty, you're viewing yourself. Oh my.
                if not permissions
                    @session.set 'SafeLink', @session.get('Authorization')
                    App.is_safelinking = false

                    navLinks.each () ->
                        # Seriously, what the hell class is this?? It makes no sense!
                        if $(this).hasClass 'disable-aye-czar'
                            $(this).removeClass 'disable-aye-czar'
                            $(this).tooltip 'destroy'
                            $(this).unbind 'hover'

                    if reload_page
                        rootScope = angular.element('body').scope()?.$root
                        rootScope?.$broadcast('app:safelinked')
                        window.dispatchEvent(new Event('app:safelinked'))

                        App.current_page?.refresh()

                else
                    @session.set 'SafeLink', "Bearer #{token}"
                    App.is_safelinking = true

                    navLinks.each () ->
                        if $(this).hasClass 'disable-aye-czar'
                            $(this).removeClass 'disable-aye-czar'
                            $(this).tooltip 'destroy'
                            $(this).unbind 'hover'

                        pname = $(this).data('permission-name') ? $(this).find('a').eq(0).text().trim()

                        if pname isnt 'Profile' and pname isnt 'More'
                            if not permissions[pname]
                                if $(this).hasClass 'active'
                                    setTimeout () ->
                                        $('a[ui-sref="grower.fields"]').trigger 'click'
                                    , 0

                                $(this).addClass 'disable-aye-czar'
                                $(this).tooltip options

                            else if $(this).hasClass 'active'
                                if reload_page
                                    setTimeout () ->
                                        $(this).find('a').trigger 'click'
                                    , 0

                    if reload_page
                        rootScope = angular.element('body').scope()?.$root?.$broadcast('app:safelinked')
                        window.dispatchEvent(new Event('app:safelinked'))


                    App.current_page?.refresh()

                    #if jsr.data?.active_sessions
                    #    @addPopup("MultipleSessionWarning", jsr.data.active_sessions)
